import { gql } from '@/__generated__';

export const livesDocument = gql(/* GraphQL */ `
  query Lives(
    $where: LiveWhereInput
    $skip: Int
    $take: Int
    $orderBy: [LiveOrderByWithRelationInput!]
  ) {
    lives(where: $where, skip: $skip, take: $take, orderBy: $orderBy) {
      id
      name
      description
      date
      active
      createdAt
      updatedAt
      _count {
        orders
        products
      }
    }
  }
`);

export const countLivesDocument = gql(/* GraphQL */ `
  query CountLives($where: LiveWhereInput!) {
    countLives(where: $where)
  }
`);

export const liveMottoDocument = gql(/* GraphQL */ `
  query LiveMotto {
    liveMotto
  }
`);

export const livesIdDocument = gql(/* GraphQL */ `
  query LivesId($where: LiveWhereInput, $orderBy: [LiveOrderByWithRelationInput!]) {
    lives(where: $where, orderBy: $orderBy) {
      id
      name
    }
  }
`);
